<template>
    <AdminEventList v-if="$store.state.auth.loggedIn && ($store.state.auth.user.role === 'admin' || $store.state.auth.user.role === 'editor' || $store.state.auth.user.role === 'limited_editor')" />
    <EventList v-else />
</template>

<script>
import AdminEventList from './admin/AdminList.vue';
import EventList from './partner/List.vue';

export default {
  components: {
    AdminEventList,
    EventList,
  },
};
</script>

<style>

</style>
